import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import logo from './mylogo.svg';


const BannerContainer = styled.div`
  background-color: #0074D9;
  color: #FFFFFF;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 30px;
  top: 2.17%;
  bottom: 94.04%;
  font-family: 'Kometa';
`;

const FieldContainer = styled.div`
  margin-right: 10px;
`;





function Banner() {
  const scrollTo = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth" });
  };

  const [visible, setVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const maxScrollPos = document.body.scrollHeight - window.innerHeight;

  useEffect(() => {
    function handleScroll() {
      const currentScrollPos = window.pageYOffset;

      if (currentScrollPos === 0 || prevScrollPos > currentScrollPos) {
        setVisible(true);
      } else if (currentScrollPos < maxScrollPos) {
        setVisible(false);
      }

      setPrevScrollPos(currentScrollPos);
    }

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);

  const bannerStyle = {
    top: '0px',
    left: '0',
    right: '0',
    alignItems: 'center',
    backgroundColor: '#052d3a',
    width: '100%',
    padding: '20px',
    paddingBottom: '1rem',
    transition: 'transform 0.3s ease-out',
    transform: visible ? 'translateY(0)' : 'translateY(-100%)',
    zIndex: "1",
  };

  const textStyle = {
    marginRight: '40px',
    textAlign: 'right',
    marginTop: '-25px'

  };

  const logoStyle = {
    width: '70px',
    height: '70px',
    marginLeft: '30px',
    marginTop: '-5px'


  };

  return (
    <div style={bannerStyle} className="banner">
      <img src={logo} style={logoStyle} className='My-logo' alt="logo" />

      <div style={textStyle}>
        <a onClick={() => scrollTo("about")} className="about-link">
          <span className="about-link_01">01.</span>
          <span className="about-link_about">ABOUT</span>
        </a>

        <a onClick={() => scrollTo("exp")} className="about-link">
          <span className="about-link_01">02.</span>
          <span className="about-link_about">SKILLS</span>
        </a>

        <a onClick={() => scrollTo("projects")} className="projects-link">
          <span className="about-link_01">03.</span>
          <span className="about-link_about">PROJECTS</span>
        </a>

        <a onClick={() => scrollTo("contact")} className="contact-link">
          <span className="about-link_01">04.</span>
          <span className="about-link_about">CONTACT</span>
        </a>

        <a href="./files/mycv.pdf" target="_blank" rel="noopener noreferrer" class="resume-button">Resume</a>

      </div>
    </div>

  );
}


export default Banner;


